import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import BarChartWithUpwardArrow from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/BarChartWithUpwardArrow';
import PaperMap from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperMap';
import PersonWithLightbulbWordBubble from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PersonWithLightbulbWordBubble';
import TwoPeopleOneWordBubble from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/TwoPeopleOneWordBubble';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'investment-advisory-services-financial-partner',
    icon: PersonWithLightbulbWordBubble,
    title: (<>A go&#45;to financial partner</>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        You&#39;ll work with an advisor who&#39;ll put your interests first and be there to guide you.
      </Typography>
    ),
  },
  {
    id: 'investment-advisory-services-investment-advice',
    icon: TwoPeopleOneWordBubble,
    title: 'Personalized advice',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        We&#39;ll build a portfolio that&#39;s aligned with your goals and monitor your account to keep it on track.
      </Typography>
    ),
  },
  {
    id: 'investment-advisory-services-portfolio-management',
    icon: PaperMap,
    title: (<>Goals&#45;based approach</>),
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        No matter what your priorities are, we&#39;ll manage your portfolio to help you reach goal after goal.
      </Typography>
    ),
  },
  {
    id: 'investment-advisory-services-diversified-portfolios',
    icon: BarChartWithUpwardArrow,
    title: 'Portfolio diversification',
    contentAs: 'div',
    content: (
      <Typography
        align='left'
        disableBottomPadding>
        Our professionally constructed, well&#45;diversified portfolios can help to balance risk and reward.
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='investment-advisory-services'
      backgroundVariant='lightB'
      headingText={<>Get more from our investment <WidowBlock>advisory services</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
